import { FormattedMessage } from 'react-intl';

import {
  FIELD_AMOUNT,
  FIELD_MEMBERS,
  FIELD_MEMBER_SELECTED,
  FIELD_GROUP_BUTTONS,
  FIELD_TEXT_REQUIRED,
  FIELD_INTEREST_RATE,
  COMMON_FIELD_NAMES,
} from './constants.fields';

export const MSG_RETIREMENTS = 'afforda.assets.details.retirement';

export const ACCOUNT_TYPE_OPTIONS = [
  {
    value: 'IRA',
    label: (
      <FormattedMessage id="afforda.assets.details.retirement.accountType.IRA" />
    ),
  },
  {
    value: 'Pension',
    label: (
      <FormattedMessage id="afforda.assets.details.retirement.accountType.Pension" />
    ),
  },
  {
    value: 'Keogh',
    label: (
      <FormattedMessage id="afforda.assets.details.retirement.accountType.Keogh" />
    ),
  },
  {
    value: '401(k)',
    label: (
      <FormattedMessage id="afforda.assets.details.retirement.accountType.401(k)" />
    ),
  },
  {
    value: 'Other',
    label: (
      <FormattedMessage id="afforda.assets.details.retirement.accountType.Other" />
    ),
  },
];

export const RETIREMENT_FIELD_NAMES = {
  memberId: COMMON_FIELD_NAMES.memberId,
  accountType: 'accountType',
  amount: COMMON_FIELD_NAMES.amount,
  feesToConvertCash: COMMON_FIELD_NAMES.feesToConvertCash,
  interestRate: COMMON_FIELD_NAMES.interestRate,
  otherAccountType: 'otherAccountType',
};

export const FIELDS = ({ intl, members, disabledMembers }) => {
  return [
    ...FIELD_MEMBERS({ members, disabledMembers }),
    // Account Type
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_GROUP_BUTTONS,
      label: (
        <FormattedMessage id="afforda.assets.details.retirement.accountType" />
      ),
      name: RETIREMENT_FIELD_NAMES.accountType,
      options: ACCOUNT_TYPE_OPTIONS,
    },
    // Other Account Type
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_TEXT_REQUIRED,
      label: (
        <FormattedMessage id="afforda.assets.details.retirement.otherAccountType" />
      ),
      placeholder: intl.formatMessage({
        id: 'afforda.assets.details.retirement.accountType',
      }),
      name: RETIREMENT_FIELD_NAMES.otherAccountType,
      watchFields: [RETIREMENT_FIELD_NAMES.accountType],
      hidden: ({ getValues }) =>
        !getValues(RETIREMENT_FIELD_NAMES.memberId)?.length ||
        getValues(RETIREMENT_FIELD_NAMES.accountType) !== 'Other',
      rules: {
        required: ({ getValues }) =>
          getValues(RETIREMENT_FIELD_NAMES.accountType) === 'Other',
      },
    },
    // Amount
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_AMOUNT,
      label: <FormattedMessage id="afforda.assets.details.retirement.amount" />,
      placeholder: '0.00',
      name: RETIREMENT_FIELD_NAMES.amount,
    },
    // Interest Rate
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_INTEREST_RATE,
      label: (
        <FormattedMessage id="afforda.assets.details.retirement.interestRate" />
      ),
      placeholder: '0.00',
      name: RETIREMENT_FIELD_NAMES.interestRate,
      helperText: (
        <FormattedMessage id="afforda.assets.details.retirement.interestRateHelperText" />
      ),
      GridProps: {
        xs: 12,
        sm: 6,
      },
      rules: { ...FIELD_INTEREST_RATE.rules, required: false },
    },
  ];
};
